<template>
  <div class="app-teaser-text">
    <dyn-slot>
      <slot name="shortTxt"></slot>
    </dyn-slot>
    <a class="show-long-txt" v-on:click="toggleLongTxt" v-if="!showLongTxt"><br>...mehr</a>
    <dyn-slot v-if="showLongTxt">
      <slot name="longTxt"></slot>
    </dyn-slot>
  </div>
</template>

<script>

export default {
  name: 'TeaserText',
  data () {
    return {
      showLong: false
    }
  },
  computed: {
    showLongTxt () {
      return this.showLong
    }
  },
  methods: {
    toggleLongTxt () {
      this.showLong = !this.showLong
    }
  },
  mixins: [
  ]
}
</script>
